export const AFTERWORK_ASSETS = `${AZURE_BASE_URL}/afterwork`

// Participation happens over WhatsApp; while '#', the CTAs stay inert.
export const AFTERWORK_WHATSAPP_URL = 'https://wa.me/message/FQWQ7UE65M6II1'

// Hero/revive keep the spots already live on the CDN; the renamed Drive
// batch (staged in public/assets/redesign/) covers the per-city content.
export const AFTERWORK_VIDEOS = {
  // Bottle + keyboard spot, matches the hero frame art
  hero: 'after-hero.mp4',
  // Venue recap footage for "Revive la experiencia"
  recap: 'revive-afterwork_recap-junio-16_9.mp4',
  // T-shirt spot for the Merch section
  merch: 'merch.mp4'
}

export const AFTERWORK_IMAGES = {
  heroLogoMobile: 'hero-afterwork_logo-mobile.webp',
  heroLogoDesktop: 'hero-afterwork_logo-desktop.webp',
  // Fallback lockup already live on the CDN (used while the batch uploads)
  heroLogoFallback: 'home-experiencias-logo_afterwork-mobile.webp',
  nextBackgroundMobile: 'proxima_edicion-background-mobile.webp',
  nextBackgroundDesktop: 'proxima_edicion-background-desktop.webp'
}

// Next-edition card data: one place to update when the edition changes.
export interface AfterworkNextEvent {
  // Pill copy, e.g. "28|08|2026 CDMX."
  dateLabel: string
  city: string
  lineup: string[]
  // CDN filenames for the lineup art (mobile/desktop)
  image: string | null
  imageDesktop: string | null
}

// September edition (work item 8596): Monterrey, no lineup announced yet.
// The new flyer asset is pending from the client (work item link is empty):
// null keeps the DOM placeholder until it reaches the CDN.
export const NEXT_EVENT: AfterworkNextEvent = {
  dateLabel: '25/09 Monterrey',
  city: 'Monterrey',
  lineup: [],
  image: null,
  imageDesktop: null
}

export interface AfterworkUpcomingExperience {
  city: string
  month: string
}

export const UPCOMING_EXPERIENCES: AfterworkUpcomingExperience[] = [
  { city: 'CDMX', month: 'Agosto' },
  { city: 'Monterrey', month: 'Septiembre' },
  { city: 'CDMX', month: 'Octubre' },
  { city: 'GDL', month: 'Noviembre' }
]

export interface AfterworkInsideEdition {
  key: string
  city: string
  // CDN filenames for the card still (mobile/desktop)
  image: string
  imageDesktop: string
  // Full video URL played by the lightbox (16:9 cut)
  videoUrl: string
}

export const INSIDE_EDITIONS: AfterworkInsideEdition[] = ['cdmx', 'monterrey', 'guadalajara', 'puebla'].map(
  (key) => ({
    key,
    city: { cdmx: 'CDMX', monterrey: 'Monterrey', guadalajara: 'Guadalajara', puebla: 'Puebla' }[key] as string,
    image: `inside_afterwork-imagen_${key}-mobile.webp`,
    imageDesktop: `inside_afterwork-imagen_${key}-desktop.webp`,
    videoUrl: `${AFTERWORK_ASSETS}/inside_afterwork-video_${key}.mp4`
  })
)
